import { Box, Typography } from '@mui/material';
import React from 'react';

import colors from '../../../../constants/colors';

interface PaymentStatusChipProps {
  failed: boolean;
  testId?: string;
}

const PaymentStatusChip = ({ failed, testId }: PaymentStatusChipProps) => {
  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: failed ? colors.csaaRed10 : colors.csaaGreen10,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          lineHeight: '16px',
          letterSpacing: 0.2,
          color: colors.csaaDark,
          fontFamily: 'Cabin',
          fontKerning: 'normal',
          fontWeight: 500,
        }}
        data-testid={testId}
      >
        {failed ? 'Failed' : 'Submitted'}
      </Typography>
    </Box>
  );
};

export default PaymentStatusChip;
